module.exports = __webpack_public_path__ + "static/img/stamp_process.dd9f4a5b.png";